export const contextMenu = {
    ContextMenuAllClosed: 'context-menu-all-closed',
    ContextMenuClosed: 'context-menu-closed',
    ContextMenuOpening: 'context-menu-opening',
    ContextMenuOpened: 'context-menu-opened',
}